/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_Notifications_DescInputs */

const en_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser and mobile push alerts`)
};

const es_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas push de navegador y móvil`)
};

const fr_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertes push navigateur et mobile`)
};

const de_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser- und mobile Push-Warnungen`)
};

const ja_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブラウザおよびモバイルのプッシュ通知`)
};

const zh_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览器和移动端推送提醒`)
};

const ar_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تنبيهات المتصفح والجوال`)
};

const id_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peringatan push dari browser dan seluler`)
};

const it_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avvisi push su browser e dispositivi mobili`)
};

const ru_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Push-оповещения в браузере и на мобильном телефоне`)
};

const pt_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alertas push no navegador e no celular`)
};

const ko_settings_push_notifications_desc = /** @type {(inputs: Settings_Push_Notifications_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`브라우저 및 모바일 푸시 알림`)
};

/**
* | output |
* | --- |
* | "Browser and mobile push alerts" |
*
* @param {Settings_Push_Notifications_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const settings_push_notifications_desc = /** @type {((inputs?: Settings_Push_Notifications_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_Notifications_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_notifications_desc(inputs)
	if (locale === "es") return es_settings_push_notifications_desc(inputs)
	if (locale === "fr") return fr_settings_push_notifications_desc(inputs)
	if (locale === "de") return de_settings_push_notifications_desc(inputs)
	if (locale === "ja") return ja_settings_push_notifications_desc(inputs)
	if (locale === "zh") return zh_settings_push_notifications_desc(inputs)
	if (locale === "ar") return ar_settings_push_notifications_desc(inputs)
	if (locale === "id") return id_settings_push_notifications_desc(inputs)
	if (locale === "it") return it_settings_push_notifications_desc(inputs)
	if (locale === "ru") return ru_settings_push_notifications_desc(inputs)
	if (locale === "pt") return pt_settings_push_notifications_desc(inputs)
	return ko_settings_push_notifications_desc(inputs)
});